module.exports = __webpack_public_path__ + "assets/media/sp1.dac0871a.mp4";